import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import LandingPage from "@/pages/LandingPage";
import Applications from "@/pages/Applications";
import Solutions from "@/pages/Solutions";
import Products from "@/pages/Products";
import Technology from "@/pages/Technology";
import About from "@/pages/About";
import Economics from "@/pages/Economics";
import Pilot from "@/pages/Pilot";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiesPolicy from "@/pages/CookiesPolicy";
import PlaceholderPage from "@/pages/PlaceholderPage";

const PLACEHOLDER_ROUTES = [];

function App() {
  useLenis();

  return (
    <div className="App bg-baseLight">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/products" element={<Products />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/about" element={<About />} />
          <Route path="/economics" element={<Economics />} />
          <Route path="/pilot" element={<Pilot />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiesPolicy />} />
          {PLACEHOLDER_ROUTES.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<PlaceholderPage eyebrow={route.eyebrow} title={route.title} description={route.description} />}
            />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;

